import React from 'react';
import { Row, Container, Button } from 'react-bootstrap';
import { useInternationalization } from '../hooks/useInternationalization';
import { LANGUAGES } from '../translations/languages';

// COMMENTATI I BOTTONI NELLA HOME PER LA SELEZIONE DELLA LINGUA

export const LanguageButtons = ({ history }) => {

    const { changeLocale } = useInternationalization();

    const languageButton = ({
        label,
        language,
        paddingX = '38px',
        fontSize = '160%',
        bgColor = '#fff',
        borderColor = '#fff',
        color = "#fff",
        disableMultilanguage
    }) => {
        return (
            <Button
                disabled={disableMultilanguage}
                style={{
                    borderRadius: 6,
                    padding: `2% ${paddingX}`,
                    fontSize: fontSize,
                    marginTop: "3%",
                    backgroundColor: bgColor,
                    borderColor: borderColor,
                    boxShadow: "0px 1pt 5pt 0px #000000",
                    fontWeight: "bold",
                    marginRight: "2%",
                    color: color,
                }}
                onClick={() => changeLocaleAndGoNext(language)}
            >{label}</Button>
        );
    };

    const changeLocaleAndGoNext = language => {
        changeLocale(language);
        history.push({ pathname: "/totem/status" });
    }

    return (
        <React.Fragment>
            <Container fluid="true" style={{
                backgroundColor: "#F5F5F5",
                paddingBottom: '2rem'
            }}>
                <Row className="align-items-center justify-content-center">
                    {languageButton({
                        label: 'ITALIANO',
                        language: LANGUAGES.IT,
                        paddingX: '65px',
                        fontSize: '250%',
                        bgColor: '#b4111a',
                        borderColor: '#b4111a',
                        disableMultilanguage: false
                    })}
                    {languageButton({
                        label: 'ENGLISH',
                        language: LANGUAGES.EN,
                        paddingX: '65px',
                        fontSize: '250%',
                        bgColor: '#b4111a',
                        borderColor: '#b4111a',
                        disableMultilanguage: true
                    })}
                </Row>
                <Row className="align-items-center justify-content-center">
                    {languageButton({
                        label: 'ESPAÑOL',
                        language: LANGUAGES.ES,
                        color: "#b4111a",
                        disableMultilanguage: true
                    })}
                    {languageButton({
                        label: 'FRANÇAIS',
                        language: LANGUAGES.FR,
                        color: "#b4111a",
                        disableMultilanguage: true
                    })}
                    {languageButton({
                        label: 'DEUTSCH',
                        language: LANGUAGES.DE,
                        color: "#b4111a",
                        disableMultilanguage: true
                    })}
                </Row>
            </Container>
        </React.Fragment>
    )
}